export const LIMIT_IMAGE_SIZE = '4000000'
